export const getIssueDiscoveryUrl = (cardKeys: string[]): string => {
	if (cardKeys.length > 1) {
		const issueKeys = cardKeys.join(',');
		const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
		return `/issues/?jql=${jqlSearch}`;
	}
	return `/browse/${cardKeys[0]}`;
};
